<template>
  <div :class="display.mobile.value ? 'mt-6 mx-2' : 'mx-1'">
    <v-overlay :model-value="showOverlay">
      <v-progress-circular color="background" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Disclaimer for checkpoint and cisco -->
    <ResultsNotPublishedDisclaimer v-if="isNotPublishedDisclaimer()" :vendor="isNotPublishedDisclaimer()"/>
    <Results
      v-else-if="allResultCategories.length
            && allModifierTypes.length
            && evaluations.length
            && (startingEvaluation || !route.query.evaluation || !setup)
            && (startingScenario || !route.query.scenario || !setup)
            && (startingVendors || !route.query.vendor || !setup)"
      :allModifierTypes="allModifierTypes"
      :allResultCategories="allResultCategories"
      :preview="false"
      :startingEvaluation="startingEvaluation"
      :startingScenario="startingScenario"
      :startingVendors="startingVendors"
      :domain="domain"
      :evaluations="evaluations"
      :vendorLogoUrl="globalProperties.$imageSrc"
      :screenshotUrl="globalProperties.$imageSrc"
      :vendorSummaryScreenshotUrl="globalProperties.$imageSrc"
      :setup="setup"
      @updateSetup="updateSetup"
    />
  </div>
</template>
<script setup>
import { ref, computed, watch, onMounted, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Results from "@attackevals/enterprise-results";
import ResultsNotPublishedDisclaimer from './ResultsNotPublishedDisclaimer.vue';
import { getDomainFromURL } from '../../mixins';
import { useDisplay } from 'vuetify'

const display = useDisplay();
const store = useStore();
const route = useRoute();
const router = useRouter();
const allModifierTypes = ref([]);
const allResultCategories = ref([]);
const evaluations = ref([]);
const showOverlay = ref(false);
const setup = ref(true);
const selectedVendorsLimit = ref(3);
const startingEvaluation = ref(undefined);

const globalProperties = inject('globalProperties');

const domain = getDomainFromURL(route.params.domain).domain;
const allAdversaries = computed(() => store.getters.allAdversaries);

const startingScenario = computed(() => {
  if (startingEvaluation.value) {
    let scenario = route.query.scenario;
    if (scenario) {
      let startingScenario = startingEvaluation.value.scenarios.find(option => option.number.toString() === scenario);
      if (!startingScenario) {
        router.replace({ query: { evaluation: startingEvaluation.value.name } });
      }
      return startingScenario;
    }
  }
  return undefined;
});
const startingVendors = computed(() => {
  let vendors = route.query.vendor;
  if (startingScenario.value && vendors) {
    let startingVendors = [];
    if (typeof vendors === 'string') {
      startingVendors = addStartingVendor(startingVendors, vendors);
    } else {
      // if user puts more than 3 vendors in the url, only use the first 3 that are active
      vendors.forEach(vendor => {
        startingVendors = addStartingVendor(startingVendors, vendor);
        });
        startingVendors = startingVendors.slice(0, selectedVendorsLimit.value);
    }
    return startingVendors;
  }
  return [];
});

function addStartingVendor(localStartingVendors, vendorName) {
  let startingVendor = startingEvaluation.value.participants.find(participant => participant.participant.name === vendorName && participant.active_flag)?.participant;
  if (startingVendor) {
    localStartingVendors.push(startingVendor);
  }
  return localStartingVendors;
}

watch(allAdversaries, (newVal) => {
  if (newVal && Object.keys(newVal).length !== 0) {
    evaluations.value = allAdversaries.value.filter(adv => adv.domain === domain && adv.status === 'PUBLISHED' && adv.scenarios.length > 0)
      .sort((a, b) => a.eval_round - b.eval_round).reverse();
    setStartingEvaluation();
  }
}, { immediate: true });

watch(() => route.query.evaluation, () => {
  if (Object.keys(allAdversaries.value).length !== 0) {
    setStartingEvaluation();
  }
}, {immediate: true})


function setStartingEvaluation() {
  let evaluation = route.query.evaluation;
  if (evaluation) {
    let filteredAdversaries = allAdversaries.value.filter(adv => adv.status !== "CALL_FOR_PARTICIPATION");
    startingEvaluation.value = filteredAdversaries.find(adversary => adversary.name === evaluation);
    if (!startingEvaluation.value) {
      router.replace({ query: {} });
    }
  }
}

function getAllModifierTypes(){
  showOverlay.value = true;
  globalProperties.$api.get(`modifier-types/`).then(response => {
    allModifierTypes.value = response.data;
    showOverlay.value = false;
  });
}

function getAllResultCategories() {
  showOverlay.value = true;
  globalProperties.$api.get(`result-categories/`).then(response => {
    allResultCategories.value = response.data;
    showOverlay.value = false;
  });
}

function updateSetup (setupBool) {
  setup.value = setupBool;
}

function isNotPublishedDisclaimer() {
  if ((route.query.evaluation === 'turla' && (route.query.vendor === 'checkpoint' || route.query.vendor === 'cisco')) || (route.query.vendor === "trendmicro" && route.query.evaluation === "oilrig")) {
    return route.query.vendor;
  }
  return false;
}

onMounted(() => {
  if (display.mobile.value) {
    selectedVendorsLimit.value = 1;
  }
  window.scrollTo(0, 0);
  getAllModifierTypes();
  getAllResultCategories();
});

</script>
<style>
  @import "@attackevals/enterprise-results/dist/output.css";
</style>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
